/*
  Firebase Config: https://firebase.google.com/docs/projects/learn-more#config-files-objects

  According to the documentation this configuration is considered public. It does recommend not pushing
  it to source control for open source projects but since I'm the only one developing it should be fine
  for me to push this.
*/
export const firebaseConfig = {
  apiKey: `AIzaSyCKlMsc2BOuN1ps4DVRk9ZkLqI6_6DHrgk`,
  authDomain: `game-please-thanks.firebaseapp.com`,
  projectId: `game-please-thanks`,
  storageBucket: `game-please-thanks.appspot.com`,
  messagingSenderId: `466431443636`,
  appId: `1:466431443636:web:14780419ea8c5480100de1`,
  measurementId: `G-C8VV0NZQVE`,
};
